export interface ICoin {
    market: string;
    korean_name: string;
    english_name: string;
}

export interface ICoinDetail {
    market: string;
    trade_date: string;
    trade_time: string;
    trade_date_kst: string;
    trade_time_kst: string;
    trade_timestamp: number;
    opening_price: number;
    high_price: number;
    low_price: number;
    trade_price: number;
    prev_closing_price: number;
    change: string;
    change_price: number;
    change_rate: number;
    signed_change_price: number;
    signed_change_rate: number;
    trade_volume: number;
    acc_trade_price: number;
    acc_trade_price_24h: number;
    acc_trade_volume: number;
    acc_trade_volume_24h: number;
    highest_52_week_price: number;
    highest_52_week_date: string;
    lowest_52_week_price: number;
    lowest_52_week_date: string;
    timestamp: number;
}

export interface IAssignCoin {
    market: string;
    korean_name: string;
    english_name: string;
    trade_date: string;
    trade_time: string;
    trade_date_kst: string;
    trade_time_kst: string;
    trade_timestamp: number;
    opening_price: number;
    high_price: number;
    low_price: number;
    trade_price: number;
    prev_closing_price: number;
    change: string;
    change_price: number;
    change_rate: number;
    signed_change_price: number;
    signed_change_rate: number;
    trade_volume: number;
    acc_trade_price: number;
    acc_trade_price_24h: number;
    acc_trade_volume: number;
    acc_trade_volume_24h: number;
    highest_52_week_price: number;
    highest_52_week_date: string;
    lowest_52_week_price: number;
    lowest_52_week_date: string;
    timestamp: number;
}

export function getMarketCoins() {
    return fetch('https://api.upbit.com/v1/market/all').then((res) => res.json());
}

export function getBtcAccPrice() {
    return fetch('https://api.upbit.com/v1/ticker?markets=KRW-BTC').then((res) => res.json());
}

export function getDetailCoin(coin: string) {
    if (coin) {
        return fetch(`https://api.upbit.com/v1/ticker?markets=${coin}`).then((res) => res.json());
    } else return null;
}
